import React from 'react'
import Header from './Header'
import Checkout from './Checkout'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import Footer from './Footer'
import '../../../App.css'

const Home = () => {
    const paymentData = useSelector((state) => state.customerData)
    const useStyles = makeStyles({
        Imagebackground: {
            backgroundPosition: 'center',
            backgroundImage:
                'url(' +
                paymentData.customerData.UIConfig.BackgroundImage +
                ')',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
        },
        ColorBackground: {
            background: paymentData.customerData.UIConfig.BackgroundColor,
        },
    })

    const classes = useStyles()
    return (
        <div
            className={
                paymentData.customerData.UIConfig.ShowBackgroundImage === true
                    ? classes.Imagebackground
                    : classes.ColorBackground
            }
        >
            <Header />
            <Checkout />
            <Footer />
        </div>
    )
}

export default Home
